var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7.75C9.08579 7.75 8.75 8.08579 8.75 8.5C8.75 8.91421 9.08579 9.25 9.5 9.25C9.91421 9.25 10.25 8.91421 10.25 8.5C10.25 8.08579 9.91421 7.75 9.5 7.75ZM7.25 8.5C7.25 7.25736 8.25736 6.25 9.5 6.25C10.7426 6.25 11.75 7.25736 11.75 8.5C11.75 9.74264 10.7426 10.75 9.5 10.75C8.25736 10.75 7.25 9.74264 7.25 8.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.82857C2 4.26639 3.26279 3 4.82051 3H19.1795C20.7372 3 22 4.26639 22 5.82857V18.1714C22 19.7336 20.7372 21 19.1795 21H4.82051C3.26279 21 2 19.7336 2 18.1714V5.82857ZM4.82051 4.54286C4.11246 4.54286 3.53846 5.11849 3.53846 5.82857V18.1714C3.53846 18.8815 4.11246 19.4571 4.82051 19.4571H19.1795C19.8875 19.4571 20.4615 18.8815 20.4615 18.1714V5.82857C20.4615 5.11849 19.8875 4.54286 19.1795 4.54286H4.82051Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46967 18.5303C2.76256 18.8232 3.23744 18.8232 3.53033 18.5303L8 14.0607L12.4697 18.5303C12.7626 18.8232 13.2374 18.8232 13.5303 18.5303C13.8232 18.2374 13.8232 17.7626 13.5303 17.4697L8.53033 12.4697C8.23744 12.1768 7.76256 12.1768 7.46967 12.4697L2.46967 17.4697C2.17678 17.7626 2.17678 18.2374 2.46967 18.5303Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4697 16.5303C10.7626 16.8232 11.2374 16.8232 11.5303 16.5303L16 12.0607L20.4697 16.5303C20.7626 16.8232 21.2374 16.8232 21.5303 16.5303C21.8232 16.2374 21.8232 15.7626 21.5303 15.4697L16.5303 10.4697C16.2374 10.1768 15.7626 10.1768 15.4697 10.4697L10.4697 15.4697C10.1768 15.7626 10.1768 16.2374 10.4697 16.5303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.54f8e2c85e33f8a1ce4ec52666b5b026.svg";
export { ForwardRef as ReactComponent };